import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

// @material-ui
import { FormLabel, FormHelperText } from '@material-ui/core'

// core
import { FileUpload } from '_core/components/FileUpload'
import { InputProgress } from '_core/components/InputProgress'

// style
import { useFileInputStyle } from './fileInputStyle'

export const RawFileInput = props => {
  const {
    className,
    name,
    label,
    error,
    checking,
    onChange,
    helperText,
    labelProps,
    progressProps,
    helperTextProps,
    Component,
    ...rest
  } = props

  const classes = useFileInputStyle()

  const rootClasses = clsx({
    [classes.root]: true,
    [className]: className != null,
  })

  return (
    <div className={rootClasses}>
      <FormLabel error={error} {...labelProps}>
        {label}
      </FormLabel>

      <Component name={name} onResultChange={onChange} {...rest} />

      {helperText != null ? (
        <div className={classes.helperTextWrap}>
          {checking ? <InputProgress {...progressProps} /> : null}

          <FormHelperText error={error} {...helperTextProps}>
            {helperText}
          </FormHelperText>
        </div>
      ) : null}
    </div>
  )
}

RawFileInput.defaultProps = {
  Component: FileUpload,
}

RawFileInput.propTypes = {
  // self props
  className: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.bool,
  checking: PropTypes.bool,
  label: PropTypes.node,
  helperText: PropTypes.node,
  labelProps: PropTypes.object,
  progressProps: PropTypes.object,
  helperTextProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  Component: PropTypes.elementType,
}

export const FileInput = RawFileInput
